import { REQUEST_FETCH_BROWSERS, FETCH_BROWSERS_SUCCESS, FETCH_BROWSERS_ERROR } from './actionTypes';

export const requestFetchBrowsers = () => ({ type: REQUEST_FETCH_BROWSERS });

export const fetchBrowsersSuccess = browsers => ({ type: FETCH_BROWSERS_SUCCESS, payload: browsers });

export const fetchBrowsersError = error => ({ type: FETCH_BROWSERS_ERROR, payload: error });
